import { THttpService } from '@/services/HttpService';

import { TTaxonomyItem } from './types';

export const getTaxonomyData = async (
  api: THttpService,
  categories: string[],
  taxonomyURL: string,
): Promise<TTaxonomyItem[]> => {
  if (!categories || categories.length === 0) {
    return [];
  }

  const convertedCategories = categories.join(',');
  const { data } = await api.get(
    `/cms/content/v1/get-content?category=${convertedCategories}`,
    {
      baseURL: taxonomyURL,
    },
  );
  return data.data;
};
